/**
 * Factory: relink
 */
angular.module('acme.common.factory.relink', [])
.factory('RelinkFactory', [function() {


  function Relink() {}

  Relink.prototype = {

    constructor: Relink,

    restore: {},
    cache: {},
    current: {},

    init: function(config) {
      this.restore = config.restore;
      this.cache = config.current;
      this.current = config.current;
    },

    equal: function(field, useOriginalFields) {
      var r;


      if (useOriginalFields &&
          (typeof(this.restore.originalFields) === 'object') &&
          this.restore.originalFields[field]) {

        if (typeof(this.restore.originalFields[field]) === 'object') {
          r = angular.equals(this.current[field], this.restore.originalFields[field]);
        }else{
          // Always string compare
          r = (String(this.current[field]) === String(this.restore.originalFields[field]));
        }

      }else if (typeof(this.restore[field]) === 'object') {
        r = angular.equals(this.current[field], this.restore[field]);
      }else{
        // Always string compare
        r = (String(this.current[field]) === String(this.restore[field]));
      }

      return r;
    },

    setCurrent: function(current) {
      this.current = current;
      this.cache = angular.copy(current);
    },

    setRestore: function(restore) {
      this.restore = restore;
    },

    //TODO: Should use recursion here this will only work with single nestings
    linkArray: function(parent, child, index, useOriginalFields) {
      if (useOriginalFields) {
        if (this.restore.originalFields &&
            this.restore.originalFields[parent] instanceof Array &&
            this.restore.originalFields[parent][index] &&
            this.restore.originalFields[parent][index][child]) {
          this.current[parent][index][child] = this.restore.originalFields[parent][index][child];
        }
      }else if (this.restore[parent] instanceof Array &&
                this.restore[parent][index] &&
                this.restore[parent][index][child]) {
        this.current[parent][index][child] = this.restore[parent][index][child];
      }
      return this.current[parent][index][child];
    },

    unlinkArray: function(parent, child, index, useOriginalFields) {
      if (useOriginalFields) {
        if (this.cache.originalFields &&
            this.cache.originalFields[parent] instanceof Array &&
            this.cache.originalFields[parent][index] &&
            this.cache.originalFields[parent][index][child]) {
            this.current[parent][index][child] = this.cache.originalFields[parent][index][child];
        }
      }else if (this.cache[parent] instanceof Array &&
                this.cache[parent][index] &&
                this.cache[parent][index][child]) {
                this.current[parent][index][child] = this.cache[parent][index][child];
      }
      return this.current[parent][index][child];
    },

    link: function(field, useOriginalFields) {
      if (useOriginalFields) {
        if (this.restore.originalFields &&
            this.restore.originalFields[field]) {
          this.current[field] = this.restore.originalFields[field];
        }else if(this.restoreField[field]){
          this.current[field] = this.restore[field];
        }
      }else{
        this.current[field] = this.restore[field];
      }
      return (typeof(this.current[field]) === 'object') ? angular.copy(this.current[field]) : this.current[field];
    },

    // pricelist is special because the property on the template is called 'priceLists' and is an array,
    // while that on the event instance is 'priceList' and is an object
    linkPriceList: function(field, useOriginalFields) {
      var restoreField = 'priceLists';

      if (useOriginalFields) {
        if (this.restore.originalFields && this.restore.originalFields[field]) {
          this.current[field] = this.restore.originalFields[field];
        } else {
          if ( (this.restore[restoreField] instanceof Array) &&
            (this.restore[restoreField].length) ) {
            this.current[field] = this.restore[restoreField][0];
          }
        }
      } else{
        if ( (this.restore[restoreField] instanceof Array) &&
          (this.restore[restoreField].length) ) {
          this.current[field] = this.restore[restoreField][0];
        }
      }
      return (typeof(this.current[field]) === 'object') ? angular.copy(this.current[field]) : this.current[field];
    },

    unlink: function(field, useOriginalFields) {
      if (useOriginalFields) {
        if (this.cache.originalFields &&
            this.cache.originalFields[field]) {
          this.current[field] = this.cache.originalFields[field];
        }
      }else {
        this.current[field] = this.cache[field];
      }
      return (typeof(this.current[field]) === 'object') ? angular.copy(this.current[field]) : this.current[field];
    }

  };

  return Relink;

}]);